// src/config/modules-registry.js

// 🔑 Central definition of all feature module keys
export const MODULE_KEYS = {
  // HRM
  HRM_EMPLOYEE: "hrm_employee",
  HRM_TICKETS: "hrm_tickets",
  HRM_HOLIDAYS: "hrm_holidays",
  HRM_ATTENDANCE: "hrm_attendance",
  HRM_PERFORMANCE: "hrm_performance",
  HRM_TRAINING: "hrm_training",
  HRM_PROMOTION: "hrm_promotion",
  HRM_RESIGNATION: "hrm_resignation",
  HRM_TERMINATION: "hrm_termination",

  // Projects
  PROJECTS: "projects",
  TASKS: "tasks",
  TASK_BOARD: "task_board",

  // CRM
  CRM_CONTACTS: "crm_contacts",
  CRM_CLIENTS: "crm_clients",
  CRM_DEALS: "crm_deals",
  CRM_LEADS: "crm_leads",
  CRM_PIPELINE: "crm_pipeline",
  CRM_ANALYTICS: "crm_analytics",
  CRM_ACTIVITIES: "crm_activities",

  // Recruitment
  RECRUIT_JOBS: "recruit_jobs",
  RECRUIT_CANDIDATES: "recruit_candidates",
  RECRUIT_REFERRALS: "recruit_referrals",

  // Finance & Accounts
  FA_SALES: "fa_sales",
  FA_ACCOUNTING: "fa_accounting",
  FA_PAYROLL: "fa_payroll",
  HRM_PAYROLL: "hrm_payroll",

  // Admin
  ADMIN_ASSETS: "admin_assets",
  ADMIN_HELP_SUPPORT: "admin_help_support",
  ADMIN_REPORTS: "admin_reports",
  ADMIN_SETTINGS: "admin_settings",
};

// 🧭 Registry that connects module keys → routes → sidebar entries
export const MODULE_REGISTRY = {
  // ========= HRM =========
  [MODULE_KEYS.HRM_EMPLOYEE]: {
    label: "HRM - Employee",
    description: "Employee list, grid, departments, designations, policies.",
    routesPrefix: ["/employee"],
    sidebar: [{ title: "HRM", menuValue: "Employee" }],
  },

  [MODULE_KEYS.HRM_TICKETS]: {
    label: "HRM - Tickets",
    description: "Support tickets module.",
    routesPrefix: ["/tickets"],
    sidebar: [{ title: "HRM", menuValue: "Tickets" }],
  },

  [MODULE_KEYS.HRM_HOLIDAYS]: {
    label: "HRM - Holidays",
    routesPrefix: ["/hrm/holidays"],
    sidebar: [{ title: "HRM", menuValue: "Holidays" }],
  },

  [MODULE_KEYS.HRM_ATTENDANCE]: {
    label: "HRM - Attendance & Leaves",
    routesPrefix: ["/attendance", "/leave"],
    sidebar: [{ title: "HRM", menuValue: "Attendance" }],
  },

  [MODULE_KEYS.HRM_PERFORMANCE]: {
    label: "HRM - Performance",
    routesPrefix: ["/performance"],
    sidebar: [{ title: "HRM", menuValue: "Performance" }],
  },

  [MODULE_KEYS.HRM_TRAINING]: {
    label: "HRM - Training",
    routesPrefix: ["/training"],
    sidebar: [{ title: "HRM", menuValue: "Training" }],
  },

  [MODULE_KEYS.HRM_PROMOTION]: {
    label: "HRM - Promotion",
    routesPrefix: ["/hrm/promotion"],
    sidebar: [{ title: "HRM", menuValue: "Promotion" }],
  },

  [MODULE_KEYS.HRM_RESIGNATION]: {
    label: "HRM - Resignation",
    routesPrefix: ["/hrm/resignation"],
    sidebar: [{ title: "HRM", menuValue: "Resignation" }],
  },

  [MODULE_KEYS.HRM_TERMINATION]: {
    label: "HRM - Termination",
    routesPrefix: ["/hrm/termination"],
    sidebar: [{ title: "HRM", menuValue: "Termination" }],
  },

  // ========= PROJECTS =========
  [MODULE_KEYS.PROJECTS]: {
    label: "Projects",
    routesPrefix: ["/projects"],
    sidebar: [{ title: "Projects", menuValue: "Projects" }],
  },

  [MODULE_KEYS.TASKS]: {
    label: "Projects - Tasks",
    routesPrefix: ["/projects/tasks"],
    sidebar: [
      { title: "Projects", menuValue: "Projects" }, // same menu group
    ],
  },

  [MODULE_KEYS.TASK_BOARD]: {
    label: "Projects - Task Board",
    routesPrefix: ["/projects/task-board"],
    sidebar: [
      { title: "Projects", menuValue: "Projects" }, // same menu group
    ],
  },

  // ========= CRM =========
  [MODULE_KEYS.CRM_CONTACTS]: {
    label: "CRM - Contacts",
    routesPrefix: ["/crm/contacts", "/crm/contacts-grid"],
    sidebar: [{ title: "CRM", menuValue: "Contacts" }],
  },

  [MODULE_KEYS.CRM_CLIENTS]: {
    label: "CRM - Clients",
    routesPrefix: ["/crm/clients", "/crm/clients-grid"],
    sidebar: [{ title: "CRM", menuValue: "Clients" }],
  },

  [MODULE_KEYS.CRM_DEALS]: {
    label: "CRM - Deals",
    routesPrefix: ["/crm/deals-list", "/crm/deals-grid"],
    sidebar: [{ title: "CRM", menuValue: "Deals" }],
  },

  [MODULE_KEYS.CRM_LEADS]: {
    label: "CRM - Leads",
    routesPrefix: ["/crm/leads-list", "/crm/leads-grid"],
    sidebar: [{ title: "CRM", menuValue: "Leads" }],
  },

  [MODULE_KEYS.CRM_PIPELINE]: {
    label: "CRM - Pipeline",
    routesPrefix: ["/crm/pipeline"],
    sidebar: [{ title: "CRM", menuValue: " Pipeline" }],
  },

  [MODULE_KEYS.CRM_ANALYTICS]: {
    label: "CRM - Analytics",
    routesPrefix: ["/crm/analytics"],
    sidebar: [{ title: "CRM", menuValue: "Analytics" }],
  },

  [MODULE_KEYS.CRM_ACTIVITIES]: {
    label: "CRM - Activities",
    routesPrefix: ["/crm/activity"],
    sidebar: [{ title: "CRM", menuValue: "Activities" }],
  },

  // ========= RECRUITMENT =========
  [MODULE_KEYS.RECRUIT_JOBS]: {
    label: "Recruitment - Jobs",
    routesPrefix: ["/recuritment/job-grid", "/recuritment/job-list"],
    sidebar: [{ title: "Recruitment", menuValue: "Jobs" }],
  },

  [MODULE_KEYS.RECRUIT_CANDIDATES]: {
    label: "Recruitment - Candidates",
    routesPrefix: [
      "/recuritment/candidates",
      "/recuritment/candidates-grid",
      "/recuritment/candidates-kanban",
    ],
    sidebar: [{ title: "Recruitment", menuValue: "Candidates" }],
  },

  [MODULE_KEYS.RECRUIT_REFERRALS]: {
    label: "Recruitment - Referrals",
    routesPrefix: ["/recuritment/refferals"],
    sidebar: [{ title: "Recruitment", menuValue: "Referrals" }],
  },

  // ========= FINANCE & ACCOUNTS =========
  [MODULE_KEYS.FA_SALES]: {
    label: "Finance - Sales",
    routesPrefix: ["/sales"],
    sidebar: [{ title: "Finance & Accounts", menuValue: "Sales" }],
  },

  [MODULE_KEYS.FA_ACCOUNTING]: {
    label: "Finance - Accounting",
    routesPrefix: ["/accounting"],
    sidebar: [{ title: "Finance & Accounts", menuValue: "Accounting" }],
  },

  [MODULE_KEYS.FA_PAYROLL]: {
    label: "Finance - Payroll",
    routesPrefix: ["/payroll"],
    sidebar: [{ title: "Finance & Accounts", menuValue: "Payroll" }],
  },

  [MODULE_KEYS.HRM_PAYROLL]: {
    label: "HRM - Payroll",
    routesPrefix: ["/payroll"],
    sidebar: [{ title: "HRM", menuValue: "Payroll" }],
  },

  // ========= ADMIN =========
  [MODULE_KEYS.ADMIN_ASSETS]: {
    label: "Admin - Assets",
    routesPrefix: ["/asset"],
    sidebar: [{ title: "Administration", menuValue: "Assets" }],
  },

  [MODULE_KEYS.ADMIN_HELP_SUPPORT]: {
    label: "Admin - Help & Support",
    routesPrefix: ["/supports"],
    sidebar: [{ title: "Administration", menuValue: "Help & Supports" }],
  },

  [MODULE_KEYS.ADMIN_REPORTS]: {
    label: "Admin - Reports",
    routesPrefix: ["/reports"],
    sidebar: [{ title: "Administration", menuValue: "Reports" }],
  },

  [MODULE_KEYS.ADMIN_SETTINGS]: {
    label: "Admin - Settings",
    routesPrefix: [
      "/general-settings",
      "/website-settings",
      "/app-settings",
      "/system-settings",
      "/financial-settings",
      "/others-settings",
      "/content",
      "/location",
      "/blog",
      "/user-management",
    ],
    sidebar: [
      { title: "Administration", menuValue: "Settings" },
      { title: "Administration", menuValue: "User Management" },
      { title: "Administration", menuValue: "Assets" }, // if you want combined per plan later
      { title: "Administration", menuValue: "Help & Supports" },
    ],
  },
};
